import { createReducer } from '@reduxjs/toolkit'
import * as registrationActions from '../actions/registration'
import { APIData, APIStatus } from '../axiosConfiguration'
import { RegistrationInfo } from '../type/registration'

type RegistrationState = {
  info: APIData<RegistrationInfo>
}

const initialState: RegistrationState = {
  info: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(registrationActions.getRegistrationInfo.fulfilled, (state, action) => {
      state.info.status = APIStatus.FULFILLED
      state.info.data = action.payload
    })
    .addCase(registrationActions.getRegistrationInfo.rejected, (state, action) => {
      state.info.status = APIStatus.REJECTED
      state.info.error = action.payload
    })
    .addCase(registrationActions.getRegistrationInfo.pending, (state) => {
      state.info.status = APIStatus.PENDING
    })
})
